import CustomFetch from "components/API/customFetch";

const postRevenueExpense = async (requestBody) => {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(requestBody)
    };

    try {
        const response = await CustomFetch(`${process.env.REACT_APP_API}/RevenueExpenses/create`, requestOptions);
      
        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Erro:', error);
       return error;
    }
};

export const updateRevenueExpense = async (id, requestBody) => {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(requestBody)
    };

    try {
        const response = await CustomFetch(`${process.env.REACT_APP_API}/RevenueExpenses/${id}`, requestOptions);
        if (!response.ok) {
            throw new Error('Erro ao enviar requisição:', response.status);
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Erro:', error);
        throw error;
    }
};


export const deleteRevenueExpense = async (id) => {
    const requestOptions = {
        method: 'DELETE',
    };

    try {
        const response = await CustomFetch(`${process.env.REACT_APP_API}/RevenueExpenses/${id}`, requestOptions);
        if (!response.ok) {
            throw new Error('Erro ao enviar requisição:', response.status);
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Erro:', error);
        throw error;
    }
};


export const getRevenueExpensesSummary = async (referenceDate) => {
    const url = new URL(`${process.env.REACT_APP_API}/RevenueExpenses`);

    if (referenceDate != null) {
        url.searchParams.append("mounthAndYerThreshold", referenceDate);
    }

    const requestOptions = {
        method: 'GET',
    };

    try {
        const response = await CustomFetch(url, requestOptions);
        if (!response.ok) {
            throw new Error('Erro ao enviar requisição:', response.status);
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Erro:', error);
        throw error;
    }
};

export const getRevenueExpensesList = async (search, category, startDate, endDate, pageSize, pageIndex) => {
    const url = new URL(`${process.env.REACT_APP_API}/RevenueExpenses/revenues-expenses-list`);

    const params = {
        search,
        category: category?.trim() || null,
        startDate: startDate ?? null ,
        endDate: endDate ?? null,
        pageSize: pageSize ?? null,
        pageIndex: pageIndex ?? null,
    };

    // Adiciona os parâmetros à URL
    Object.keys(params).forEach(key => {
        if (params[key] !== null) {
            url.searchParams.append(key, params[key]);
        }
    });

    const requestOptions = {
        method: 'GET',
    };

    try {
        const response = await CustomFetch(url, requestOptions);
        if (!response.ok) {
            throw new Error('Erro ao enviar requisição:', response.status);
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Erro:', error);
        throw error;
    }
};

export const getRevenueExpenseAutocomplete = async (search, limit = 8) => {
    const normalizedSearch = search.trim().toLocaleLowerCase();
    const data = await getRevenueExpensesList(search, null, null, null, 50, 1);
    const results = Array.isArray(data?.results) ? data.results : [];
    const uniqueNames = new Set();

    return results
        .filter((item) => item.name?.trim().toLocaleLowerCase().includes(normalizedSearch))
        .filter((item) => {
            const normalizedName = item.name.trim().toLocaleLowerCase();
            if (uniqueNames.has(normalizedName)) {
                return false;
            }

            uniqueNames.add(normalizedName);
            return true;
        })
        .sort((left, right) => {
            const normalizedLeftName = left.name.trim().toLocaleLowerCase();
            const normalizedRightName = right.name.trim().toLocaleLowerCase();
            const leftIsExactMatch = normalizedLeftName === normalizedSearch;
            const rightIsExactMatch = normalizedRightName === normalizedSearch;

            if (leftIsExactMatch !== rightIsExactMatch) {
                return leftIsExactMatch ? -1 : 1;
            }

            const leftStartsWithSearch = normalizedLeftName.startsWith(normalizedSearch);
            const rightStartsWithSearch = normalizedRightName.startsWith(normalizedSearch);

            if (leftStartsWithSearch !== rightStartsWithSearch) {
                return leftStartsWithSearch ? -1 : 1;
            }

            return left.name.localeCompare(right.name, 'pt-BR');
        })
        .slice(0, limit);
};

const getApiErrorMessage = async (response, fallbackMessage) => {
    const clonedResponse = response.clone();

    try {
        const data = await clonedResponse.json();
        return data?.detail || data?.message || fallbackMessage;
    } catch (error) {
        try {
            const text = await response.text();
            return text || fallbackMessage;
        } catch {
            return fallbackMessage;
        }
    }
};

export const getRevenueExpensesExport = async (search, category, startDate, endDate) => {
    const url = new URL(`${process.env.REACT_APP_API}/RevenueExpenses/revenues-expenses-export`);

    const params = {
        search: search?.trim() || null,
        category: category?.trim() || null,
        startDate: startDate ?? null,
        endDate: endDate ?? null,
    };

    Object.keys(params).forEach(key => {
        if (params[key] !== null) {
            url.searchParams.append(key, params[key]);
        }
    });

    const requestOptions = {
        method: 'GET',
    };

    try {
        const response = await CustomFetch(url, requestOptions);
        if (!response.ok) {
            throw new Error(await getApiErrorMessage(response, "Não foi possível exportar o extrato."));
        }

        return await response.json();
    } catch (error) {
        console.error('Erro:', error);
        throw error;
    }
};

export const getRevenueExpensesYearDetails = async () => {
    const requestOptions = {
        method: 'GET',
    };

    try {
        const response = await CustomFetch(`${process.env.REACT_APP_API}/RevenueExpenses/revenues-expenses-year`, requestOptions);
        if (!response.ok) {
            throw new Error('Erro ao enviar requisição:', response.status);
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Erro:', error);
        throw error;
    }

};

export const getRevenueExpenseCategorySummary = async (type, referenceDate) => {
    const url = new URL(`${process.env.REACT_APP_API}/RevenueExpenses/category-summary`);

    if (type != null) {
        url.searchParams.append("type", type);
    }

    if (referenceDate != null) {
        url.searchParams.append("referenceDate", referenceDate);
    }

    const requestOptions = {
        method: 'GET',
    };

    try {
        const response = await CustomFetch(url, requestOptions);
        if (!response.ok) {
            throw new Error('Erro ao enviar requisição:', response.status);
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Erro:', error);
        throw error;
    }
};

export const getRevenueExpenseCategoryLimits = async (type = 2) => {
    const url = new URL(`${process.env.REACT_APP_API}/RevenueExpenses/category-limits`);

    if (type != null) {
        url.searchParams.append("type", type);
    }

    const requestOptions = {
        method: 'GET',
    };

    try {
        const response = await CustomFetch(url, requestOptions);
        if (!response.ok) {
            throw new Error('Erro ao enviar requisição:', response.status);
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Erro:', error);
        throw error;
    }
};

export const upsertRevenueExpenseCategoryLimit = async (requestBody) => {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(requestBody)
    };

    try {
        const response = await CustomFetch(`${process.env.REACT_APP_API}/RevenueExpenses/category-limits`, requestOptions);
        if (!response.ok) {
            throw new Error('Erro ao enviar requisição:', response.status);
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Erro:', error);
        throw error;
    }
};

export const deleteRevenueExpenseCategoryLimit = async ({ type, category }) => {
    const url = new URL(`${process.env.REACT_APP_API}/RevenueExpenses/category-limits`);

    if (type != null) {
        url.searchParams.append("type", type);
    }

    if (category != null) {
        url.searchParams.append("category", category);
    }

    const requestOptions = {
        method: 'DELETE',
    };

    try {
        const response = await CustomFetch(url, requestOptions);
        if (!response.ok) {
            throw new Error('Erro ao enviar requisição:', response.status);
        }

        return true;
    } catch (error) {
        console.error('Erro:', error);
        throw error;
    }
};

export const getWeekExpensesDetails = async () => {
    const requestOptions = {
        method: 'GET',
    };

    try {
        const response = await CustomFetch(`${process.env.REACT_APP_API}/RevenueExpenses/weekly-summary`, requestOptions);
        if (!response.ok) {
            throw new Error('Erro ao enviar requisição:', response.status);
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Erro:', error);
        throw error;
    }
};


export const getRevenueExpenseById = async (id) => {
    const requestOptions = {
        method: 'GET',
    };

    try {
        const response = await CustomFetch(`${process.env.REACT_APP_API}/RevenueExpenses/${id}`, requestOptions);
        if (!response.ok) {
            throw new Error('Erro ao enviar requisição:', response.status);
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Erro:', error);
        throw error;
    }
};


export default postRevenueExpense;
